module.exports = __webpack_public_path__ + "img/43-s.78a3dc91.png";